import { render, staticRenderFns } from "./View14.vue?vue&type=template&id=65680c26&scoped=true&"
import script from "./View14.vue?vue&type=script&lang=js&"
export * from "./View14.vue?vue&type=script&lang=js&"
import style0 from "./View14.vue?vue&type=style&index=0&id=65680c26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65680c26",
  null
  
)

export default component.exports